var React = require('react');

function IcArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.504 3.33337L14.1707 10L7.504 16.6667L5.83337 15L10.8373 10L5.83337 5.00004L7.504 3.33337Z","fill":"#282C34"}));
}

IcArrowRight.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcArrowRight;

IcArrowRight.default = IcArrowRight;
